// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import t from '../types';

/**
 * Retrieve A/P aging details for a specific vendor.
 */
export function useAPAgingDetails(vendorId, query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.AP_AGING_DETAILS, vendorId, query],
    {
      method: 'get',
      url: `/financial_statements/payable_aging_details/vendor/${vendorId}`,
      params: query,
    },
    {
      select: (res) => res.data,
      enabled: !!vendorId,
      ...props,
    },
  );
}
